import { render, staticRenderFns } from "./veStuAssocFundsShow.vue?vue&type=template&id=7aed68c5&scoped=true"
import script from "./veStuAssocFundsShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocFundsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aed68c5",
  null
  
)

export default component.exports